/* TASK 14A ΠΙΛΟΤΟΣ — stone-sync: κρατά τις γραμμές-διαμάντια ΠΑΝΤΑ ίσες με ό,τι
   δηλώνουν τα _stone_variant properties των δαχτυλιδιών (desired = server-side
   monopetro-stone-data στο drawer/cart — pattern TASK 3 engraving-sync).
   Ορφανή πέτρα (δαχτυλίδι αφαιρέθηκε) → βγαίνει. Πέτρα που λείπει → ξαναμπαίνει.
   Αν η επαναπροσθήκη ΑΠΟΤΥΧΕΙ (πέτρα πουλήθηκε — απόθεμα 1) → fail-CLOSED:
   αφαιρείται ΚΑΙ το δαχτυλίδι + ειδοποίηση (όχι πώληση σκελετού χωρίς πέτρα —
   συνειδητή διαφορά από το fail-open του χαράγματος: 15€ fee vs το ίδιο το διαμάντι). */
(function () {
  'use strict';
  var syncing = false;

  function readDesired() {
    var el = document.querySelector('[data-mono-desired]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var dialog = document.querySelector('[data-cart-drawer]');
        if (dialog && data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          dialog.firstElementChild.innerHTML = tmp.firstElementChild.innerHTML;
        }
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        });
      });
  }

  /* fail-CLOSED δίχτυ: πέτρα δεν επανέρχεται → φεύγουν και τα δαχτυλίδια της */
  function dropRingsFor(vid) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var keys = (cart.items || []).filter(function (it) {
          return it.properties && String(it.properties._stone_variant) === String(vid);
        }).map(function (it) { return it.key; });
        var chain = Promise.resolve();
        keys.forEach(function (k) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: k, quantity: 0 })
            });
          });
        });
        return chain.then(function () {
          if (keys.length) alert('Το διαμάντι της παραγγελίας σας δεν είναι πλέον διαθέσιμο. Το δαχτυλίδι αφαιρέθηκε από το καλάθι — παρακαλούμε επιλέξτε άλλη πέτρα.');
        });
      });
  }

  function sync() {
    if (syncing) return;
    var desired = readDesired();
    if (!desired) return;
    syncing = true;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* MERGE-aware (βήμα-1 Cart Transform): merged γραμμή (has_components:true)
           = δαχτυλίδι+πέτρα ΗΔΗ ενωμένα → αυτοϊκανοποιημένο ζευγάρι, ΔΕΝ «θέλει»
           πέτρα-γραμμή (αλλιώς churn: ο sync ξαναπρόσθετε την πέτρα — E2E-εύρημα).
           Το want χτίζεται πλέον από το ΙΔΙΟ /cart.js (α-merged δαχτυλίδια μόνο)·
           το wantsCsv του Liquid μένει ως έχει (server-truth για το drawer render). */
        var want = {};
        (cart.items || []).forEach(function (it) {
          var sv = it.properties && it.properties._stone_variant;
          if (sv && !it.has_components) want[String(sv)] = (want[String(sv)] || 0) + 1;
        });
        var current = {};
        (cart.items || []).forEach(function (it) {
          if (it.handle === desired.stoneHandle) current[String(it.variant_id)] = it.quantity;
        });
        /* E2E-εύρημα πιλότου: γραμμή-δαχτυλίδι με δεμένη πέτρα (_stone_variant)
           = ΜΟΝΑΔΙΚΟ ζευγάρι → quantity ΠΑΝΤΑ 1 (merge από 2ο ATC ή qty-πεδίο
           στο cart page θα πλήρωνε 2ο σκελετό ΧΩΡΙΣ 2η πέτρα). change.js με key. */
        var overRings = (cart.items || []).filter(function (it) {
          return it.properties && it.properties._stone_variant && it.quantity > 1;
        });
        if (overRings.length) {
          var clamp = Promise.resolve();
          overRings.forEach(function (it) {
            clamp = clamp.then(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: it.key, quantity: 1 })
              });
            });
          });
          return clamp.then(function () {
            alert('Το μονόπετρο με το επιλεγμένο διαμάντι μπορεί να προστεθεί μόνο μία φορά — κάθε πέτρα είναι μοναδική. Για δεύτερο δαχτυλίδι επιλέξτε διαφορετική πέτρα.');
            return refreshDrawer();
          });
        }
        var updates = {};
        Object.keys(current).forEach(function (vid) {
          if ((want[vid] || 0) !== current[vid]) updates[vid] = want[vid] || 0;
        });
        Object.keys(want).forEach(function (vid) {
          if (!(vid in current)) updates[vid] = want[vid];
        });
        var vids = Object.keys(updates);
        if (!vids.length) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          if (r.ok) return refreshDrawer();
          /* κάποια πέτρα δεν μπόρεσε να μπει → βρες ποιες wanted λείπουν ακόμα */
          return fetch('/cart.js').then(function (r2) { return r2.json(); }).then(function (c2) {
            var have = {};
            (c2.items || []).forEach(function (it) {
              if (it.handle === desired.stoneHandle) have[String(it.variant_id)] = true;
            });
            var chain = Promise.resolve();
            Object.keys(want).forEach(function (vid) {
              if (!have[vid]) chain = chain.then(function () { return dropRingsFor(vid); });
            });
            return chain.then(refreshDrawer);
          });
        });
      })
      .catch(function () { /* δίκτυο: ο επόμενος cart:updated ξαναπροσπαθεί */ })
      .then(function () { syncing = false; }, function () { syncing = false; });
  }

  document.addEventListener('cart:updated', sync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
